import { Button, Modal, Descriptions, Tabs, Table, Typography } from 'antd'
import React, { Children, useEffect, useState } from 'react'
import metaData from 'metadata/questionlogs'
import { IQuestionLogs } from 'interfaces'
import { useNavigation, useTable } from '@pankod/refine-core'
import { Icons, Timeline, DateField } from '@pankod/refine-antd'
import { getQuestionUsageAnalysis } from 'gql/query'
import { Data } from 'react-csv/components/CommonPropTypes'
import { CSVLink } from 'react-csv'
import { type } from 'os'
import { nhost } from 'utility'

const { Text } = Typography
const { ExportOutlined, ArrowDownOutlined } = Icons

type QuestionUsageAnalysisProps = {
  questionId: any
  questionTitle:any
}
type Details={
  id:number
  name:string
  count:number
}
type BodyData={
  type:string
  children:Details[]
}

const dummy = [
  {
    description: 'Shyam has created this question in work request id : 2131 (dummy)',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil has been assinged to review this question in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil have reviewed and passed the question to Mini for approval in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil rejected this question at review stage in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Sunil (Reviewer) returned this question to Shyam (Creator) for amending in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini have approved and set this question to published status in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini rejected this question at approval stage in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Mini (Approver) returned this question to Sunil (Reviewer) for amending in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
  {
    description: 'Shyam has edited this question in work request id : 2131',
    created_at: '2022-06-30T04:04:00.484286+00:00',
  },
]

const QuestionUsageAnalysis: React.FC<QuestionUsageAnalysisProps> = ({ questionId,questionTitle }) => {
  console.log({questionId});
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [usageData, setUsageData] = useState<any>()
  const [sectionData, setSectionData] = useState<any[] | undefined>()
  const [paperData, setPaperData] = useState<any[] | undefined>()
  const [testeventData, settestEventData] = useState<any[] | undefined>()
  const [exportData, setExportData] = useState<string | Data | (() => string | Data)>('')
  const [exportDataArray, setExportDataArray] = useState<BodyData[]>([])
  const [exportDataLoading, setExportDataLoading] = useState<boolean>(true)
  const [isPrinting,setPrinting] =useState<boolean>(false)
 
  const { show } = useNavigation()

  const { TabPane } = Tabs

  useEffect(() => {
    if(questionId){
    getQuestionUsageAnalysis(questionId).then((resp: any) => {
      setUsageData(resp?.question_usage_analysis_aggregate?.nodes)
    })
  }
  }, [questionId])

  useEffect(() => {
    if (usageData) {
      let _sectionData: any[] = []
      let _paperData: any[] = []
      let _testEventData: any[] = []
      usageData.forEach((item: any) => {
        const paperIndex = _paperData.findIndex(paper => paper?.id === item?.id)
        const sectionIndex = _sectionData.findIndex(section => section?.id === item?.id)
        const testEventIndex = _testEventData.findIndex(testEvent => testEvent?.id === item?.id)

        _paperData.push({ id: item?.paper_id, paperSmartId: `#${item?.paper?.paper_id}-${item?.paper?.paper_smart_id}` })

        if (sectionIndex === -1) {
          _sectionData.push({ id: item?.section_id, name: item?.section?.name, count: 1 })
        } else {
          _sectionData[sectionIndex].count = _sectionData[sectionIndex]?.count + 1
        }

        if (testEventIndex === -1) {
          _testEventData.push({ id: item?.test_event_id, name: item?.test_event?.name, count: 1 })
        } else {
          _testEventData[testEventIndex].count = _sectionData[testEventIndex]?.count + 1
        }
      })
      setSectionData(_sectionData)
      setPaperData(_paperData)
      settestEventData(_testEventData)
    }
  }, [usageData])

  const fetchExportData = async () => {
    let data = ''
    let dataArray:BodyData[]=[]
        data = data.concat('Section Usage, Name, Count\n')
       
      dataArray.push({type:"section_details",children:[]},{type:"test_event_details",children:[]},{type:"paper_details",children:[]})
    sectionData?.forEach((item, idx) => {
      data = data.concat(`${idx + 1},${item.name},${item.count}\n`)
      let found=dataArray.findIndex(item=>item?.type==='section_details')
      if(found!==-1){
     
          dataArray[found]?.children.push({id:idx + 1,
            name:item.name,
            count:item.count})
      }
      // dataArray.push({
      //   type:'section_details',
      //   id:idx + 1,
      //   name:item.name,
      //   count:item.count
      // })
    })
    data = data.concat('\n')

    data = data.concat('Test Event Usage, Name, Count\n')
    testeventData?.forEach((item, idx) => {
      data = data.concat(`${idx + 1},${item.name},${item.count}\n`)
      let found=dataArray.findIndex(item=>item?.type==='test_event_details')
      if(found!==-1){
     
          dataArray[found]?.children.push({id:idx + 1,
            name:item.name,
            count:item.count})
      }
     
    })
    data = data.concat('\n')

    data = data.concat('Paper Usage, Smart Id\n')
    paperData?.forEach((item, idx) => {
      data = data.concat(`${idx + 1},${item.paperSmartId}\n`)
      let found=dataArray.findIndex(item=>item?.type==='paper_details')
      if(found!==-1){
     
          dataArray[found]?.children.push({id:idx + 1,
            name:item.paperSmartId,
            count:1})
      }
    
    })

    setExportData(data)
    setExportDataArray(dataArray)
    setExportDataLoading(false)
  }

  useEffect(() => {
    if (sectionData && paperData && testeventData) {
      fetchExportData()
    }
  }, [sectionData, paperData, testeventData])

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    setPrinting(false)
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setPrinting(false)
    setIsModalVisible(false)
    setPrinting(false)
  }
  const printToPdf = () => {
    setPrinting(true)

    let details: object[] = []

    details.push({ exportData: exportDataArray,questionTitle:questionTitle})
      fetch(`${process.env.REACT_APP_BACKEND_URL}/create-usage-analysis-pdf`, {
  //  fetch('http://localhost:3001/create-usage-analysis-pdf', {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      body: JSON.stringify(details),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
    .then(response => response.json())
        .then(data => {
          console.log({data})
        const publicUrl = nhost.storage.getPublicUrl({ fileId: data?.id || '' })
        console.log({publicUrl});
        setPrinting(false)
        // const objectURL = URL.createObjectURL(publicUrl);
       window.open(publicUrl, '_blank');
        // resp.blob().then((myBlob) => {
        //   const objectURL = URL.createObjectURL(myBlob);
        //   window.open(objectURL, '_blank');
        //   // setDownload(false)

        //   // myImage.src = objectURL;
        // });


      }
      )

  }
  return (
    <>
      <Button key="logs" onClick={showModal} icon={<Icons.FileSearchOutlined />}>
        Usage Analysis
      </Button>
      <Modal title="Usage Analysis" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} style={{ minWidth: '1000px' }}>
        <div style={{ display: 'flex',justifyContent:'end'}}>
          <Button key="export paper" type="default">
            {exportDataLoading ? (
              'Loading...'
            ) : (
              <CSVLink key="export" data={exportData} filename={`Usage_Analysis_${questionId}_${Math.round(new Date().getTime() / 1000)}`}>
                <ExportOutlined /> Export Usage Data
              </CSVLink>
            )}
          </Button>
          <Button loading={isPrinting} icon={<Icons.PrinterFilled/>} style={{marginLeft:10}} onClick={printToPdf}>
              Print
            </Button>
        </div>
        <b>Usage List:</b>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Papers" key="1">
            {paperData?.map((item, idx) => (
              <>
                {idx + 1}.
                <Button type="link" onClick={(): void => show('papers', item?.id)}>
                  {item?.paperSmartId}
                </Button>
              </>
            ))}
          </TabPane>
          <TabPane tab="Test Events" key="2">
            <Table
              style={{ width: '50%' }}
              size="small"
              columns={[
                {
                  title: '',
                  dataIndex: 'idx',
                  render: (text, record, index) => <Text>{index + 1}</Text>,
                },
                {
                  title: 'Name',
                  dataIndex: 'name',
                  render: (text, record, index) => (
                    <Button type="link" style={{ padding: '0' }} onClick={(): void => show('test_events', record?.id)}>
                      {text}
                    </Button>
                  ),
                },
                {
                  title: 'Count',
                  dataIndex: 'count',
                },
              ]}
              dataSource={testeventData}
              pagination={false}
            />
          </TabPane>
          <TabPane tab="Sections" key="3">
            <Table
              style={{ width: '50%' }}
              size="small"
              columns={[
                {
                  title: '',
                  dataIndex: 'idx',
                  render: (text, record, index) => <Text>{index + 1}</Text>,
                },
                {
                  title: 'Name',
                  dataIndex: 'name',
                },
                {
                  title: 'Count',
                  dataIndex: 'count',
                },
              ]}
              dataSource={sectionData}
              pagination={false}
            />
          </TabPane>
        </Tabs>

        {/* {tableQueryResult?.data?.data?.map(log => {
          return (
            <Timeline.Item>
              <div>{log.description}</div>
              <DateField format="LLL" value={log.created_at} />
            </Timeline.Item>
          )
        })} */}
      </Modal>
    </>
  )
}

export default QuestionUsageAnalysis
